import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as o } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const i = o((e, r) => /* @__PURE__ */ s.jsx(
  t,
  {
    ref: r,
    ...e,
    image: (a) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...a,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3500",
              width: 16,
              height: 16,
              x: 0,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M15.25 7.25h-6.5V.75C8.75.34 8.41 0 8 0s-.75.34-.75.75v6.5H.75C.34 7.25 0 7.59 0 8s.34.75.75.75h6.5v6.5c0 .41.34.75.75.75s.75-.34.75-.75v-6.5h6.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3500)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
i.displayName = "AgencyPlusIcon";
export {
  i as AgencyPlusIcon,
  i as default
};
//# sourceMappingURL=index.js.map
